export default "__VITE_PUBLIC_ASSET__a6ff86b2__"